<template>
  <div>
    <div class="flex items-center br2 justify-between pa3 bg-nord4">
      <div class="dib flex items-center">
        <div>
          <p class="f7 mv0 ttu tracked-tight">Currently Tracking</p>
          <span class="dib b" v-if="task">{{task.text}} </span>
        </div>
        <div v-if="elapsed" class="f3 br2 mh3 ba b--transparent bw1 bg-nord6 ph3 pv1 b" :class="{nord11: tracking, 'b--nord11': tracking}">
          {{elapsed}} 
        </div>
      </div>
      <button v-if="task && tracking" class="outline-0 fa fa-pause fa-lg bg-nord4 nord11 ba br-100 pa3 bw2 b--nord11" @click="pause"></button>
      <button v-if="task && !tracking" class="outline-0 fa fa-play fa-lg bg-nord4 nord9 ba br-100 pa3 bw2 b--nord9" @click="play"></button>
    </div>
  </div>
</template>
<script>
import {msToTime} from "../util/format.js"
export default {
  data: function(){
    return {
      task: null,
      time: null,
      elapsed: null,
      tracking: false,
    }
  },
  methods: {
    updateElapsed(){
      if(this.task && this.tracking){
        this.elapsed = msToTime(Date.now() - this.time)
      }
    },
    pause(){
      if(!this.tracking) return;
      var seconds = ((Date.now() - this.time)/1000)
      this.$root.$emit(this.task.id.toString(), Math.floor(seconds))
      this.elapsed = msToTime(0)
      this.tracking = false
    },
    play(){
      this.time = Date.now()
      this.tracking = true
    }
  },
  mounted() {
    if(localStorage.task){
      this.task = JSON.parse(localStorage.task)
    }
    if(localStorage.time){
      this.time = localStorage.time
    }
    if(localStorage.tracking){
      this.tracking = JSON.parse(localStorage.tracking)
    }
    window.setInterval(this.updateElapsed.bind(this), 1000)
    this.$root.$on('track', task => {
      if(this.task != null){
        this.pause()
      }
      this.task = task
      this.play()
    })
    this.$root.$on('removeTracking', id => {
      if(this.task != null && this.task.id == id){
        this.task = null
      }
    })
    this.$root.$on('trackingTask', cb => {
      cb(this.tracking, this.task)
    })
  },
  watch: {
    task: {
      handler: (task) => {
        localStorage.task = JSON.stringify(task)
      },
      deep: true
    },
    time: {
      handler: (time) => {
        localStorage.time = time
      },
    },
    tracking: {
      handler: (tracking) => {
        localStorage.tracking = tracking
      },
    },
  }
}
</script>
